module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    staticClass: "center-xs",
    attrs: {
      "maxWidth": "600px",
      "height": "600px",
      "padding": '2em'
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "0"
    }
  }, [_c('pl-button', {
    staticStyle: {
      "min-width": "0"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('strong', {
    staticClass: "f4"
  }, [_vm._v("X")])])], 1), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "src": _vm.logo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt3 b f3"
  }, [_vm._v("Select a Course Work")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body-container",
    staticStyle: {
      "height": "300px",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "row col-xs no-margin center-xs select-classroom"
  }, [_c('pl-select', {
    staticClass: "mb4",
    attrs: {
      "options": _vm.courseWorks,
      "label": "title",
      "selected": _vm.selected_rt,
      "arrow": true,
      "placeholder": 'Select a Course Work'
    },
    on: {
      "change": function($event) {
        return _vm.selectCourseWork($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row no-margin center-xs"
  }, [_c('pl-button', [_vm._v(" BACK ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-primary",
    attrs: {
      "disabled": !_vm.selected_rt
    },
    nativeOn: {
      "click": function($event) {
        return _vm.syncCourseWork.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      NEXT\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-69a5c2a1!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/rtGoogleClassroomModal.vue
// module id = 995
// module chunks = 61